import { HoldingClass, Partner, StockPlan } from 'types';
import { PartnerBookPartnersRegister } from '../types/PartnerBook';
import views from '../constants/views';

type GetButtonIdProps = {
  view: number;
  partners: Partner[];
  plans: StockPlan[];
  holdingClasses: HoldingClass[];
  partnersRegister: PartnerBookPartnersRegister;
};

const buttons = {
  equity: 'equityBtn',
  comercial: 'comercialBtn',
  summaryInvestors: 'summaryInvestorsBtn',
  summary: 'summaryBtn',
  summaryAccumulated: 'summaryAccumulatedBtn',
};

export const getButtonId = ({
  view,
  partners,
  plans,
  holdingClasses,
  partnersRegister,
}: GetButtonIdProps) => {
  const isCommercialView =
    view === views.COMMERCIAL_REGISTER &&
    partners?.length > 0 &&
    partnersRegister;

  const isSummaryView =
    view === views.SUMMARY &&
    partners.length > 0 &&
    plans &&
    holdingClasses.length > 0;

  const isSummaryAccumulatedView =
    view === views.SUMMARY_ACCUMULATED &&
    partners.length > 0 &&
    plans &&
    holdingClasses.length > 0;

  const isSummaryInvestorsView =
    view === views.SUMMARY_INVESTORS &&
    partners.length > 0 &&
    plans &&
    holdingClasses.length > 0;

  if (isCommercialView) {
    return buttons.comercial;
  }
  if (isSummaryView) {
    return buttons.summary;
  }
  if (isSummaryAccumulatedView) {
    return buttons.summaryAccumulated;
  }
  if (isSummaryInvestorsView) {
    return buttons.summaryInvestors;
  }

  return '';
};
